module.exports = __webpack_public_path__ + "img/presession_blue.dbb0f532.svg";